<template>
    <div>hi</div>
</template>

<script>
export default {
    name: "HomeView",
};
</script>
